import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state: {
        allCoins: [],
        pagination: { page: 1, size: 25 }
    },
    mutations: {
        setAllcoins(state, payload) {
            state.allCoins = payload;
        },
        setPagination(state, payload) {
            state.pagination = payload;
        }
    },
    actions: {}
};

appStore.registerModule('automaticAudit', store);